export default __webpack_public_path__ + "static/media/Img_tools_supplies.f41655ef.svg";